import React from "react";
import { Popover, Typography, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CheckIcon } from "../ChatiaIcons";

// X próprio do popover — menor e proporcional ao tamanho do popover
const PopoverCloseIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" {...props}>
		<path d="M18 6L6 18M6 6l12 12" />
	</svg>
);

export { CheckIcon };

const useStyles = makeStyles((theme) => ({
	paper: {
		borderRadius: 14,
		minWidth: 230,
		overflow: "hidden",
		boxShadow: "0 10px 36px rgba(0,0,0,0.14)",
		border: "none",
		background: theme.mode === "dark" ? "#121212" : "#ffffff",
	},
	header: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: "10px 14px",
		background: theme.palette.primary.main,
		color: theme.palette.primary.contrastText || "#ffffff",
		borderBottom: "none",
	},
	headerTitle: {
		fontWeight: 600,
		fontSize: 13,
		color: "inherit",
	},
	closeButton: {
		padding: 3,
		backgroundColor: "rgba(255, 255, 255, 0.08)",
		color: "#ffffff",
		transition: "all 0.2s ease",
		"&:hover": {
			backgroundColor: "rgba(255, 255, 255, 0.18)",
			color: "#ffffff",
		},
	},
	content: {
		padding: 6,
		...theme.scrollbarStylesSoft,
		maxHeight: 400,
		overflowY: "auto",
	},
	// === Option item padrão ===
	optionItem: {
		display: "flex",
		alignItems: "center",
		gap: 12,
		padding: "9px 12px",
		marginBottom: 4,
		borderRadius: 8,
		cursor: "pointer",
		transition: "all 0.15s ease",
		"&:hover": {
			background: theme.mode === "dark"
				? "rgba(255,255,255,0.06)"
				: "rgba(0,0,0,0.04)",
		},
	},
	optionItemSelected: {
		background: "rgba(6, 207, 156, 0.10)",
		"&:hover": {
			background: "rgba(6, 207, 156, 0.15)",
		},
	},
	optionIcon: {
		width: 30,
		height: 20,
		objectFit: "cover",
		borderRadius: 3,
		flexShrink: 0,
		border: theme.mode === "dark"
			? "1px solid rgba(255,255,255,0.12)"
			: "1px solid rgba(0,0,0,0.1)",
	},
	optionName: {
		fontSize: 14,
		fontWeight: 500,
		color: theme.mode === "dark" ? "#ffffff" : "#1a1a1a",
		flex: 1,
	},
	optionCheck: {
		width: 18,
		height: 18,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: "#06cf9c",
		flexShrink: 0,
	},
}));

// === Item de opção padronizado ===
export const PopoverOptionItem = ({ icon, label, selected, onClick, children }) => {
	const classes = useStyles();
	return (
		<div
			className={`${classes.optionItem} ${selected ? classes.optionItemSelected : ""}`}
			onClick={onClick}
		>
			{icon && (
				typeof icon === "string"
					? <img src={icon} alt={label} className={classes.optionIcon} />
					: icon
			)}
			{children || (
				<Typography className={classes.optionName}>{label}</Typography>
			)}
			<div className={classes.optionCheck}>
				{selected && <CheckIcon />}
			</div>
		</div>
	);
};

// === Popover container ===
const ChatiaPopover = ({
	open,
	anchorEl,
	onClose,
	title,
	anchorOrigin = { vertical: "bottom", horizontal: "center" },
	transformOrigin = { vertical: "top", horizontal: "center" },
	children,
	paperStyle,
}) => {
	const classes = useStyles();

	return (
		<Popover
			open={open}
			anchorEl={anchorEl}
			onClose={onClose}
			anchorOrigin={anchorOrigin}
			transformOrigin={transformOrigin}
			PaperProps={{
				className: classes.paper,
				style: paperStyle,
			}}
			disableScrollLock
		>
			{title && (
				<div className={classes.header}>
					<Typography className={classes.headerTitle}>
						{title}
					</Typography>
					<IconButton
						size="small"
						onClick={onClose}
						className={classes.closeButton}
					>
						<PopoverCloseIcon />
					</IconButton>
				</div>
			)}
			<div className={classes.content}>
				{children}
			</div>
		</Popover>
	);
};

export default ChatiaPopover;
